//--------------- IMPORTAÇÕES ---------------//
import { useContext, useState } from "react";
import { toast } from "react-toastify";
import OfertasLastlinkPicker, { useOfertasLastlink, aplicarVinculosOfertas } from "../OfertasLastlinkPicker";
import { ProdutosContext } from "../../context/ProdutosContext";
import { createProductService, loadProductsService } from "../../services";



//------=--------- EXPORTAÇÕES ---------------//
export default function ModalCreateProduct() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { isOpenModalCreateProduct, setIsOpenModalCreateProduct } = useContext(ProdutosContext); // Estado que armazena se o Modal de criação de Produto está aberto ou não
    const { formDataModalCreateProduct, setFormDataModalCreateProduct } = useContext(ProdutosContext); // Estado que armazena o Objeto Formulário do Modal de criação de Produto
    const { setProducts } = useContext(ProdutosContext);
    const ofertasLastlink = useOfertasLastlink();
    const [ofertasSelecionadas, setOfertasSelecionadas] = useState(new Set());



    //--------------- FUNÇÃO ASSÍNCRONA CARREGAR PRODUTOS ---------------//
    // Responsável por requisitar à API os produtos existentes
    // Armazena no Estado "produtos" a lista de produtos retornadas pela API
    async function handleRefreshProducts() {
        const response = await loadProductsService();
        if (response) {
            setProducts(response.data);
        }
    };



    //--------------- FUNÇÃO ASSÍNCRONA SALVAR PRODUTO ---------------//
    // Responsável por salvar o Produto via API
    async function handleSaveProduct() {

        const response = await createProductService(formDataModalCreateProduct);
        if (response) {
            if (response.id && ofertasSelecionadas.size > 0) {
                try { await aplicarVinculosOfertas(ofertasLastlink, response.id, ofertasSelecionadas); }
                catch (e) { toast.error(e?.response?.data?.error || "Produto criado, mas falhou ao vincular ofertas da Lastlink"); }
            }
            setOfertasSelecionadas(new Set());
            setIsOpenModalCreateProduct(false);
            handleRefreshProducts();
        }
    };



    //------------------ RETORNO CONDICIONAL DO MODAL ADD TAGS BULK ------------------//
    return (
        <>
            {/* MODAL DE EDITAR OU CRIAR PRODUTO */}
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                <div className="bg-surface-2 p-6 rounded-xl w-full max-w-lg border border-white/[0.08] max-h-[90vh] overflow-y-auto">
                    <h2 className="text-xl font-bold mb-4">Novo Produto</h2>
                    <input
                        type="text"
                        placeholder="Nome"
                        value={formDataModalCreateProduct.nome || ""}
                        onChange={(e) => setFormDataModalCreateProduct({ ...formDataModalCreateProduct, nome: e.target.value })}
                        className="bg-surface-1 border border-white/[0.08] p-3 rounded text-white w-full mb-3"
                    />
                                        <p className="text-xs text-ink-3 mb-2">IDs nas plataformas — informe pelo menos um. Cadastre <b>antes da primeira venda</b> para o pixel/snippet do produto já ficar vinculado (o webhook casa a venda por esse ID).</p>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 mb-3">
                        <div>
                            <label className="block text-xs text-ink-3 mb-1">ID Hotmart</label>
                            <input
                                type="text"
                                placeholder="ex.: 4821234"
                                value={formDataModalCreateProduct.id_produto_hotmart || ""}
                                onChange={(e) => setFormDataModalCreateProduct({ ...formDataModalCreateProduct, id_produto_hotmart: e.target.value })}
                                className="bg-surface-1 border border-white/[0.08] p-3 rounded text-white w-full"
                            />
                        </div>
                        <div>
                            <label className="block text-xs text-ink-3 mb-1">ID Kiwify</label>
                            <input
                                type="text"
                                placeholder="ex.: 3a8f..."
                                value={formDataModalCreateProduct.id_produto_kiwify || ""}
                                onChange={(e) => setFormDataModalCreateProduct({ ...formDataModalCreateProduct, id_produto_kiwify: e.target.value })}
                                className="bg-surface-1 border border-white/[0.08] p-3 rounded text-white w-full"
                            />
                        </div>
                        <div>
                            <label className="block text-xs text-ink-3 mb-1">ID Lastlink</label>
                            <input
                                type="text"
                                placeholder="uuid do produto"
                                value={formDataModalCreateProduct.id_produto_lastlink || ""}
                                onChange={(e) => setFormDataModalCreateProduct({ ...formDataModalCreateProduct, id_produto_lastlink: e.target.value })}
                                className="bg-surface-1 border border-white/[0.08] p-3 rounded text-white w-full font-mono text-xs"
                            />
                        </div>
                    </div>

                    <OfertasLastlinkPicker ofertas={ofertasLastlink} selecionadas={ofertasSelecionadas} setSelecionadas={setOfertasSelecionadas} produtoId={null} />

                    {/* Fase 2 — opcionais: contexto usado pelo agente IA. */}
                    <label className="block text-xs text-ink-3 mb-1">Descrição do produto (opcional)</label>
                    <textarea
                        placeholder="Resumo curto do produto"
                        value={formDataModalCreateProduct.descricao || ""}
                        onChange={(e) => setFormDataModalCreateProduct({ ...formDataModalCreateProduct, descricao: e.target.value })}
                        className="bg-surface-1 border border-white/[0.08] p-3 rounded text-white text-sm w-full mb-3 min-h-[80px] resize-y"
                    />
                    <label className="block text-xs text-ink-3 mb-1">Conhecimento extra (opcional)</label>
                    <textarea
                        placeholder="Informações detalhadas (ementa, garantia, FAQ rápido)"
                        value={formDataModalCreateProduct.conhecimento_extra || ""}
                        onChange={(e) => setFormDataModalCreateProduct({ ...formDataModalCreateProduct, conhecimento_extra: e.target.value })}
                        className="bg-surface-1 border border-white/[0.08] p-3 rounded text-white text-sm w-full mb-4 min-h-[120px] resize-y"
                    />

                    <div className="flex justify-end gap-2">
                        <button
                            onClick={() => {
                                setFormDataModalCreateProduct({ nome: "", id_produto_hotmart: "", id_produto_kiwify: "", id_produto_lastlink: "", descricao: "", conhecimento_extra: "" });
                                setIsOpenModalCreateProduct(false);
                            }}
                            className="bg-surface-3 hover:bg-surface-4 px-4 py-2 rounded"
                        >
                            Cancelar
                        </button>
                        <button
                            onClick={handleSaveProduct}
                            className="bg-green-600 hover:bg-green-700 px-4 py-2 rounded"
                        >
                            Salvar
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}